import { combineEpics, createEpicMiddleware } from 'redux-observable';

import { authApi, AuthApi } from '@ui/api/auth';
import { RegionApi, regionApi } from '@ui/api/region';
import { StoreApi, storeApi } from '@ui/api/store';
import { userApi, UserApi } from '@ui/api/user';
import { CollectionApi, collectionApi } from '@ui/api/collection';

import { epics as countriesEpics } from '@ui/scenes/Countries';
import { epics as storesEpics } from '@ui/scenes/Stores';
import { epics as createStoreEpics } from '@ui/scenes/CreateStore';
import { epics as mainEpics } from '../Main';
import { epics as authEpics } from './auth';
import { epics as metaEpics } from './meta';
import { epics as managersEpics } from '@ui/scenes/Managers';
import { epics as collectionsEpics } from '@ui/scenes/Collections';
import { epics as regionsEpics } from '@ui/scenes/Regions';
import { epics as citiesEpics } from '@ui/scenes/Cities';
import { epics as cityStoresEpics } from '@ui/scenes/CityStores';
import { epics as storeEpics } from '@ui/scenes/Store';
import { epics as requestsEpics } from '@ui/scenes/Requests';
import { epics as editStoreEpics } from '@ui/scenes/EditStore';

export interface EpicDependencies {
  authApi: AuthApi;
  regionApi: RegionApi;
  storeApi: StoreApi;
  userApi: UserApi;
  collectionApi: CollectionApi;
}

const rootEpic = combineEpics(
  mainEpics,
  authEpics,
  countriesEpics,
  storesEpics,
  metaEpics,
  createStoreEpics,
  managersEpics,
  collectionsEpics,
  regionsEpics,
  citiesEpics,
  cityStoresEpics,
  storeEpics,
  requestsEpics,
  editStoreEpics,
);

const epicMiddleware = createEpicMiddleware({
  dependencies: {
    authApi,
    regionApi,
    storeApi,
    userApi,
    collectionApi,
  },
});

export { rootEpic, epicMiddleware };



// WEBPACK FOOTER //
// ./src/store/rootEpic.ts